"use strict";

exports.__esModule = true;
exports.VertexAttachment = exports.Attachment = void 0;

var _Utils = require("../Utils");

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/** The base class for all attachments. */
var Attachment = function Attachment(name) {
  if (!name) throw new Error("name cannot be null.");
  this.name = name;
};
/** Base class for an attachment with vertices that are transformed by one or more bones and can be deformed by a slot's
 * {@link Slot#deform}. */


exports.Attachment = Attachment;

var VertexAttachment = /*#__PURE__*/function (_Attachment) {
  _inheritsLoose(VertexAttachment, _Attachment);

  function VertexAttachment(name) {
    var _this;

    _this = _Attachment.call(this, name) || this;
    /** The unique ID for this attachment. */

    _this.id = VertexAttachment.nextID++;
    /** The bones which affect the {@link #getVertices()}. The array entries are, for each vertex, the number of bones affecting
     * the vertex followed by that many bone indices, which is the index of the bone in {@link Skeleton#bones}. Will be null
     * if this attachment has no weights. */

    _this.bones = null;
    /** The vertex positions in the bone's coordinate system. For a non-weighted attachment, the values are `x,y`
     * entries for each vertex. For a weighted attachment, the values are `x,y,weight` entries for each bone affecting
     * each vertex. */

    _this.vertices = null;
    /** The maximum number of world vertex values that can be output by
     * {@link #computeWorldVertices()} using the `count` parameter. */

    _this.worldVerticesLength = 0;
    /** Deform keys for the deform attachment are also applied to this attachment. May be null if no deform keys should be applied. */

    _this.deformAttachment = _assertThisInitialized(_this);
    return _this;
  }
  /** Transforms the attachment's local {@link #vertices} to world coordinates. If the slot's {@link Slot#deform} is
   * not empty, it is used to deform the vertices.
   *
   * See [World transforms](http://esotericsoftware.com/spine-runtime-skeletons#World-transforms) in the Spine
   * Runtimes Guide.
   * @param start The index of the first {@link #vertices} value to transform. Each vertex has 2 values, x and y.
   * @param count The number of world vertex values to output. Must be <= {@link #worldVerticesLength} - `start`.
   * @param worldVertices The output world vertices. Must have a length >= `offset` + `count` *
   *           `stride` / 2.
   * @param offset The `worldVertices` index to begin writing values.
   * @param stride The number of `worldVertices` entries between the value pairs written. */


  var _proto = VertexAttachment.prototype;

  _proto.computeWorldVertices = function computeWorldVertices(slot, start, count, worldVertices, offset, stride) {
    count = offset + (count >> 1) * stride;
    var skeleton = slot.bone.skeleton;
    var deformArray = slot.deform;
    var vertices = this.vertices;
    var bones = this.bones;

    if (!bones) {
      if (deformArray.length > 0) vertices = deformArray;
      var bone = slot.bone;
      var x = bone.worldX;
      var y = bone.worldY;
      var a = bone.a,
          b = bone.b,
          c = bone.c,
          d = bone.d;

      for (var _v = start, w = offset; w < count; _v += 2, w += stride) {
        var vx = vertices[_v],
            vy = vertices[_v + 1];
        worldVertices[w] = vx * a + vy * b + x;
        worldVertices[w + 1] = vx * c + vy * d + y;
      }

      return;
    }

    var v = 0,
        skip = 0;

    for (var i = 0; i < start; i += 2) {
      var n = bones[v];
      v += n + 1;
      skip += n;
    }

    var skeletonBones = skeleton.bones;

    if (deformArray.length == 0) {
      for (var _w = offset, _b = skip * 3; _w < count; _w += stride) {
        var wx = 0,
            wy = 0;
        var _n = bones[v++];
        _n += v;

        for (; v < _n; v++, _b += 3) {
          var _bone = skeletonBones[bones[v]];
          var _vx = vertices[_b],
              _vy = vertices[_b + 1],
              weight = vertices[_b + 2];
          wx += (_vx * _bone.a + _vy * _bone.b + _bone.worldX) * weight;
          wy += (_vx * _bone.c + _vy * _bone.d + _bone.worldY) * weight;
        }

        worldVertices[_w] = wx;
        worldVertices[_w + 1] = wy;
      }
    } else {
      var deform = deformArray;

      for (var _w2 = offset, _b2 = skip * 3, f = skip << 1; _w2 < count; _w2 += stride) {
        var _wx = 0,
            _wy = 0;
        var _n2 = bones[v++];
        _n2 += v;

        for (; v < _n2; v++, _b2 += 3, f += 2) {
          var _bone2 = skeletonBones[bones[v]];

          var _vx2 = vertices[_b2] + deform[f],
              _vy2 = vertices[_b2 + 1] + deform[f + 1],
              _weight = vertices[_b2 + 2];

          _wx += (_vx2 * _bone2.a + _vy2 * _bone2.b + _bone2.worldX) * _weight;
          _wy += (_vx2 * _bone2.c + _vy2 * _bone2.d + _bone2.worldY) * _weight;
        }

        worldVertices[_w2] = _wx;
        worldVertices[_w2 + 1] = _wy;
      }
    }
  }
  /** Does not copy id (generated) or name (set on construction). **/
  ;

  _proto.copyTo = function copyTo(attachment) {
    if (this.bones) {
      attachment.bones = new Array(this.bones.length);

      _Utils.Utils.arrayCopy(this.bones, 0, attachment.bones, 0, this.bones.length);
    } else attachment.bones = null;

    if (this.vertices) {
      attachment.vertices = _Utils.Utils.newFloatArray(this.vertices.length);

      _Utils.Utils.arrayCopy(this.vertices, 0, attachment.vertices, 0, this.vertices.length);
    } else attachment.vertices = null;

    attachment.worldVerticesLength = this.worldVerticesLength;
    attachment.deformAttachment = this.deformAttachment;
  };

  return VertexAttachment;
}(Attachment);

exports.VertexAttachment = VertexAttachment;
VertexAttachment.nextID = 0;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7QUE4QkE7Ozs7Ozs7O0FBRUE7SUFDc0JBLFUsR0FHckIsb0JBQWFDLElBQWIsRUFBeUI7RUFDeEIsSUFBSSxDQUFDQSxJQUFMLEVBQVcsTUFBTSxJQUFJQyxLQUFKLENBQVUsc0JBQVYsQ0FBTjtFQUNYLEtBQUtELElBQUwsR0FBWUEsSUFBWjtBQUNBLEM7QUFLRjs7Ozs7O0lBRXNCRSxnQjs7O0VBdUJyQiwwQkFBYUYsSUFBYixFQUF5QjtJQUFBOztJQUN4QiwrQkFBTUEsSUFBTjtJQXJCRDs7SUFDQSxXQUFLRSxnQkFBZ0IsQ0FBQ0MsTUFBakIsRUFBTDtJQUVBOzs7O0lBR0EsY0FBdUIsSUFBdkI7SUFFQTs7OztJQUdBLGlCQUE0QixJQUE1QjtJQUVBOzs7SUFFQSw0QkFBc0IsQ0FBdEI7SUFFQTs7SUFDQTtJQUV5QjtFQUV4QjtFQUVEOzs7Ozs7Ozs7Ozs7Ozs7U0FXQUMsb0IsR0FBQSw4QkFBc0JDLElBQXRCLEVBQWtDQyxLQUFsQyxFQUFpREMsS0FBakQsRUFBZ0VDLGFBQWhFLEVBQWdHQyxNQUFoRyxFQUFnSEMsTUFBaEgsRUFBOEg7SUFDN0hILEtBQUssR0FBR0UsTUFBTSxHQUFHLENBQUNGLEtBQUssSUFBSSxDQUFWLElBQWVHLE1BQWhDO0lBQ0EsSUFBSUMsUUFBUSxHQUFHTixJQUFJLENBQUNPLElBQUwsQ0FBVUQsUUFBekI7SUFDQSxJQUFJRSxXQUFXLEdBQUdSLElBQUksQ0FBQ1MsTUFBdkI7SUFDQSxJQUFJQyxRQUFRLEdBQUcsS0FBS0EsUUFBcEI7SUFDQSxJQUFJQyxLQUFLLEdBQUcsS0FBS0EsS0FBakI7O0lBQ0EsSUFBSSxDQUFDQSxLQUFMLEVBQVk7TUFDWCxJQUFJSCxXQUFXLENBQUNJLE1BQVosR0FBcUIsQ0FBekIsRUFBNEJGLFFBQVEsR0FBR0YsV0FBWDtNQUM1QixJQUFJRCxJQUFJLEdBQUdQLElBQUksQ0FBQ08sSUFBaEI7TUFDQSxJQUFJTSxDQUFDLEdBQUdOLElBQUksQ0FBQ08sTUFBYjtNQUNBLElBQUlDLENBQUMsR0FBR1IsSUFBSSxDQUFDUyxNQUFiO01BQ0EsSUFBSUMsQ0FBQyxHQUFHVixJQUFJLENBQUNVLENBQWI7TUFBQSxJQUFnQkMsQ0FBQyxHQUFHWCxJQUFJLENBQUNXLENBQXpCO01BQUEsSUFBNEJDLENBQUMsR0FBR1osSUFBSSxDQUFDWSxDQUFyQztNQUFBLElBQXdDQyxDQUFDLEdBQUdiLElBQUksQ0FBQ2EsQ0FBakQ7O01BQ0EsS0FBSyxJQUFJQyxFQUFDLEdBQUdwQixLQUFSLEVBQWVxQixDQUFDLEdBQUdsQixNQUF4QixFQUFnQ2tCLENBQUMsR0FBR3BCLEtBQXBDLEVBQTJDbUIsRUFBQyxJQUFJLENBQUwsRUFBUUMsQ0FBQyxJQUFJakIsTUFBeEQsRUFBZ0U7UUFDL0QsSUFBSWtCLEVBQUUsR0FBR2IsUUFBUSxDQUFDVyxFQUFELENBQWpCO1FBQUEsSUFBc0JHLEVBQUUsR0FBR2QsUUFBUSxDQUFDVyxFQUFDLEdBQUcsQ0FBTCxDQUFuQztRQUNBbEIsYUFBYSxDQUFDbUIsQ0FBRCxDQUFiLEdBQW1CQyxFQUFFLEdBQUdOLENBQUwsR0FBU08sRUFBRSxHQUFHTixDQUFkLEdBQWtCTCxDQUFyQztRQUNBVixhQUFhLENBQUNtQixDQUFDLEdBQUcsQ0FBTCxDQUFiLEdBQXVCQyxFQUFFLEdBQUdKLENBQUwsR0FBU0ssRUFBRSxHQUFHSixDQUFkLEdBQWtCTCxDQUF6QztNQUNBOztNQUNEO0lBQ0E7O0lBQ0QsSUFBSU0sQ0FBQyxHQUFHLENBQVI7SUFBQSxJQUFXSSxJQUFJLEdBQUcsQ0FBbEI7O0lBQ0EsS0FBSyxJQUFJQyxDQUFDLEdBQUcsQ0FBYixFQUFnQkEsQ0FBQyxHQUFHekIsS0FBcEIsRUFBMkJ5QixDQUFDLElBQUksQ0FBaEMsRUFBbUM7TUFDbEMsSUFBSUMsQ0FBQyxHQUFHaEIsS0FBSyxDQUFDVSxDQUFELENBQWI7TUFDQUEsQ0FBQyxJQUFJTSxDQUFDLEdBQUcsQ0FBVDtNQUNBRixJQUFJLElBQUlFLENBQVI7SUFDQTs7SUFDRCxJQUFJQyxhQUFhLEdBQUd0QixRQUFRLENBQUNLLEtBQTdCOztJQUNBLElBQUlILFdBQVcsQ0FBQ0ksTUFBWixJQUFzQixDQUExQixFQUE2QjtNQUM1QixLQUFLLElBQUlVLEVBQUMsR0FBR2xCLE1BQVIsRUFBZ0JjLEVBQUMsR0FBR08sSUFBSSxHQUFHLENBQWhDLEVBQW1DSCxFQUFDLEdBQUdwQixLQUF2QyxFQUE4Q29CLEVBQUMsSUFBSWpCLE1BQW5ELEVBQTJEO1FBQzFELElBQUl3QixFQUFFLEdBQUcsQ0FBVDtRQUFBLElBQVlDLEVBQUUsR0FBRyxDQUFqQjtRQUNBLElBQUlILEVBQUMsR0FBR2hCLEtBQUssQ0FBQ1UsQ0FBQyxFQUFGLENBQWI7UUFDQU0sRUFBQyxJQUFJTixDQUFMOztRQUNBLE9BQU9BLENBQUMsR0FBR00sRUFBWCxFQUFjTixDQUFDLElBQUlILEVBQUMsSUFBSSxDQUF4QixFQUEyQjtVQUMxQixJQUFJWCxLQUFJLEdBQUdxQixhQUFhLENBQUNqQixLQUFLLENBQUNVLENBQUQsQ0FBTixDQUF4QjtVQUNBLElBQUlFLEdBQUUsR0FBR2IsUUFBUSxDQUFDUSxFQUFELENBQWpCO1VBQUEsSUFBc0JNLEdBQUUsR0FBR2QsUUFBUSxDQUFDUSxFQUFDLEdBQUcsQ0FBTCxDQUFuQztVQUFBLElBQTRDYSxNQUFNLEdBQUdyQixRQUFRLENBQUNRLEVBQUMsR0FBRyxDQUFMLENBQTdEO1VBQ0FXLEVBQUUsSUFBSSxDQUFDTixHQUFFLEdBQUdoQixLQUFJLENBQUNVLENBQVYsR0FBY08sR0FBRSxHQUFHakIsS0FBSSxDQUFDVyxDQUF4QixHQUE0QlgsS0FBSSxDQUFDTyxNQUFsQyxJQUE0Q2lCLE1BQWxEO1VBQ0FELEVBQUUsSUFBSSxDQUFDUCxHQUFFLEdBQUdoQixLQUFJLENBQUNZLENBQVYsR0FBY0ssR0FBRSxHQUFHakIsS0FBSSxDQUFDYSxDQUF4QixHQUE0QmIsS0FBSSxDQUFDUyxNQUFsQyxJQUE0Q2UsTUFBbEQ7UUFDQTs7UUFDRDVCLGFBQWEsQ0FBQ21CLEVBQUQsQ0FBYixHQUFtQk8sRUFBbkI7UUFDQTFCLGFBQWEsQ0FBQ21CLEVBQUMsR0FBRyxDQUFMLENBQWIsR0FBdUJRLEVBQXZCO01BQ0E7SUFDRCxDQWRELE1BY087TUFDTixJQUFJckIsTUFBTSxHQUFHRCxXQUFiOztNQUNBLEtBQUssSUFBSWMsR0FBQyxHQUFHbEIsTUFBUixFQUFnQmMsR0FBQyxHQUFHTyxJQUFJLEdBQUcsQ0FBM0IsRUFBOEJPLENBQUMsR0FBR1AsSUFBSSxJQUFJLENBQS9DLEVBQWtESCxHQUFDLEdBQUdwQixLQUF0RCxFQUE2RG9CLEdBQUMsSUFBSWpCLE1BQWxFLEVBQTBFO1FBQ3pFLElBQUl3QixHQUFFLEdBQUcsQ0FBVDtRQUFBLElBQVlDLEdBQUUsR0FBRyxDQUFqQjtRQUNBLElBQUlILEdBQUMsR0FBR2hCLEtBQUssQ0FBQ1UsQ0FBQyxFQUFGLENBQWI7UUFDQU0sR0FBQyxJQUFJTixDQUFMOztRQUNBLE9BQU9BLENBQUMsR0FBR00sR0FBWCxFQUFjTixDQUFDLElBQUlILEdBQUMsSUFBSSxDQUFULEVBQVljLENBQUMsSUFBSSxDQUFoQyxFQUFtQztVQUNsQyxJQUFJekIsTUFBSSxHQUFHcUIsYUFBYSxDQUFDakIsS0FBSyxDQUFDVSxDQUFELENBQU4sQ0FBeEI7O1VBQ0EsSUFBSUUsSUFBRSxHQUFHYixRQUFRLENBQUNRLEdBQUQsQ0FBUixHQUFjVCxNQUFNLENBQUN1QixDQUFELENBQTdCO1VBQUEsSUFBa0NSLElBQUUsR0FBR2QsUUFBUSxDQUFDUSxHQUFDLEdBQUcsQ0FBTCxDQUFSLEdBQWtCVCxNQUFNLENBQUN1QixDQUFDLEdBQUcsQ0FBTCxDQUEvRDtVQUFBLElBQXdFRCxPQUFNLEdBQUdyQixRQUFRLENBQUNRLEdBQUMsR0FBRyxDQUFMLENBQXpGOztVQUNBVyxHQUFFLElBQUksQ0FBQ04sSUFBRSxHQUFHaEIsTUFBSSxDQUFDVSxDQUFWLEdBQWNPLElBQUUsR0FBR2pCLE1BQUksQ0FBQ1csQ0FBeEIsR0FBNEJYLE1BQUksQ0FBQ08sTUFBbEMsSUFBNENpQixPQUFsRDtVQUNBRCxHQUFFLElBQUksQ0FBQ1AsSUFBRSxHQUFHaEIsTUFBSSxDQUFDWSxDQUFWLEdBQWNLLElBQUUsR0FBR2pCLE1BQUksQ0FBQ2EsQ0FBeEIsR0FBNEJiLE1BQUksQ0FBQ1MsTUFBbEMsSUFBNENlLE9BQWxEO1FBQ0E7O1FBQ0Q1QixhQUFhLENBQUNtQixHQUFELENBQWIsR0FBbUJPLEdBQW5CO1FBQ0ExQixhQUFhLENBQUNtQixHQUFDLEdBQUcsQ0FBTCxDQUFiLEdBQXVCUSxHQUF2QjtNQUNBO0lBQ0Q7RUFDRDtFQUVEOzs7U0FDQUcsTSxHQUFBLGdCQUFRQyxVQUFSLEVBQW9DO0lBQ25DLElBQUksS0FBS3ZCLEtBQVQsRUFBZ0I7TUFDZnVCLFVBQVUsQ0FBQ3ZCLEtBQVgsR0FBbUIsSUFBSXdCLEtBQUosQ0FBa0IsS0FBS3hCLEtBQUwsQ0FBV0MsTUFBN0IsQ0FBbkI7O01BQ0F3QixhQUFNQyxTQUFOLENBQWdCLEtBQUsxQixLQUFyQixFQUE0QixDQUE1QixFQUErQnVCLFVBQVUsQ0FBQ3ZCLEtBQTFDLEVBQWlELENBQWpELEVBQW9ELEtBQUtBLEtBQUwsQ0FBV0MsTUFBL0Q7SUFDQSxDQUhELE1BSUNzQixVQUFVLENBQUN2QixLQUFYLEdBQW1CLElBQW5COztJQUVELElBQUksS0FBS0QsUUFBVCxFQUFtQjtNQUNsQndCLFVBQVUsQ0FBQ3hCLFFBQVgsR0FBc0IwQixhQUFNRSxhQUFOLENBQW9CLEtBQUs1QixRQUFMLENBQWNFLE1BQWxDLENBQXRCOztNQUNBd0IsYUFBTUMsU0FBTixDQUFnQixLQUFLM0IsUUFBckIsRUFBK0IsQ0FBL0IsRUFBa0N3QixVQUFVLENBQUN4QixRQUE3QyxFQUF1RCxDQUF2RCxFQUEwRCxLQUFLQSxRQUFMLENBQWNFLE1BQXhFO0lBQ0EsQ0FIRCxNQUlDc0IsVUFBVSxDQUFDeEIsUUFBWCxHQUFzQixJQUF0Qjs7SUFFRHdCLFVBQVUsQ0FBQ0ssbUJBQVgsR0FBaUMsS0FBS0EsbUJBQXRDO0lBQ0FMLFVBQVUsQ0FBQ00sZ0JBQVgsR0FBOEIsS0FBS0EsZ0JBQW5DO0VBQ0EsQzs7O0VBaEg2QzlDLFU7OztBQUMvQkcsMEJBQVMsQ0FBVCIsIm5hbWVzIjpbIkF0dGFjaG1lbnQiLCJuYW1lIiwiRXJyb3IiLCJWZXJ0ZXhBdHRhY2htZW50IiwibmV4dElEIiwiY29tcHV0ZVdvcmxkVmVydGljZXMiLCJzbG90Iiwic3RhcnQiLCJjb3VudCIsIndvcmxkVmVydGljZXMiLCJvZmZzZXQiLCJzdHJpZGUiLCJza2VsZXRvbiIsImJvbmUiLCJkZWZvcm1BcnJheSIsImRlZm9ybSIsInZlcnRpY2VzIiwiYm9uZXMiLCJsZW5ndGgiLCJ4Iiwid29ybGRYIiwieSIsIndvcmxkWSIsImEiLCJiIiwiYyIsImQiLCJ2IiwidyIsInZ4IiwidnkiLCJza2lwIiwiaSIsIm4iLCJza2VsZXRvbkJvbmVzIiwid3giLCJ3eSIsIndlaWdodCIsImYiLCJjb3B5VG8iLCJhdHRhY2htZW50IiwiQXJyYXkiLCJVdGlscyIsImFycmF5Q29weSIsIm5ld0Zsb2F0QXJyYXkiLCJ3b3JsZFZlcnRpY2VzTGVuZ3RoIiwiZGVmb3JtQXR0YWNobWVudCJdLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvYXR0YWNobWVudHMvQXR0YWNobWVudC50cyJdLCJzb3VyY2VzQ29udGVudCI6W251bGxdfQ==